module.exports = __webpack_public_path__ + "img/buy.a6f5a885.png";